// extracted by mini-css-extract-plugin
module.exports = {"suggested-searches":"suggested-searches__9AGW6","title":"title__wLs0d","items":"items__nZHfS","item":"item__wNXxO"};